// ChatMessage.js
import React from "react";
import { LiveChatStyles as styles } from "./chat.tailwind";
import { useSelector } from "react-redux";
import { LIVE_GAME_CHAT_CONTENT_TYPE, getFirstCharUpperCase, getRandomColor } from "../../../../../../lib/constants/globalConstant";
import CommentaryMessage from "./CommentaryMessage";
// import ImageMessage from "./ImageMessage";
// import VideoMessage from "./VideoMessage";
import { Avatar, Tooltip } from "@mui/material";
import ImagePreviewForLiveChat from "./ImagePreviewForLiveChat";

const ChatMessage = ({ message, handleReplayCommentary }) => {
  const { user } = useSelector((state) => state.user);
  const isUser = (user?.userDetails?._id === message.userId) || (user?.userDetails?._id === message?.userId?._id);

  // Get the first character and its color
  const firstChar = getFirstCharUpperCase(message?.userNickName);
  const avatarColor = getRandomColor(firstChar);

  if (message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.COMMENTARY) {
    return <CommentaryMessage message={message} handleReplayCommentary={handleReplayCommentary} />
  }

  // if (message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.IMAGE) {
  //   return <ImageMessage message={message} isUser={isUser} />
  // }

  // if (message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.VIDEO) {
  //   return <VideoMessage message={message} isUser={isUser} />
  // }

  // if (message?.contentType !== LIVE_GAME_CHAT_CONTENT_TYPE.TEXT || message?.contentType !== LIVE_GAME_CHAT_CONTENT_TYPE.BOTH_TEXT_MEDIA || message?.contentType !== LIVE_GAME_CHAT_CONTENT_TYPE.MEDIA) {
  //   return null;
  // }

  // If the message contains a URL, replace it with an <img> element
  const renderMessageContent = (message) => {
    // if(message?.attachmentURLs?.length === 0) return;

    if ((message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.IMAGE || message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.VIDEO || message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.BOTH_TEXT_MEDIA || message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.MEDIA) && message?.attachmentURLs?.length > 0 ) { 
      return <ImagePreviewForLiveChat attachmentURLs={message?.attachmentURLs} autoSlide={false} slideInterval={3000} showControls={true} isUser={isUser} chatId={message?._id} />;
    }

    return (message.messageText);
  };

  return (
    <div className={styles.mb3}>
      <div className={`${isUser ? "flex flex-row-reverse gap-2 items-end" : "flex gap-2 items-end"}`}>
        {/* Sender Image */}
        {(message?.attachmentURLs?.length > 0 || message?.messageText?.trim() !== "" ) && <Tooltip arrow={true} title={message?.userNickName} sx={{ fontSize: '10px' }}>
          {message?.userProfileImage ? (
            <div className={styles.senderImageContainer}>
              <img src={message?.userProfileImage} alt="Sender" className={styles.senderImage} />
            </div>
          ) : (
            <Avatar sx={{ width: 24, height: 24, bgcolor: avatarColor, fontSize: 10, lineHeight: '8px' }}>
              {firstChar}
            </Avatar>
          )}
        </Tooltip>}

        {/* main Message Text */}
        {message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.BOTH_TEXT_MEDIA ? (
          <div className="flex flex-col rounded-[12px] gap-1">
            <pre className={`${styles.messageContainer} ${(message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.MEDIA || message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.BOTH_TEXT_MEDIA) ? `${styles.mediaContainer} p-0` : "px-4 py-2 bg-themeOverlay "}`} >
              {renderMessageContent(message)}
            </pre>
            {
              (message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.BOTH_TEXT_MEDIA && message?.messageText?.trim() !== "") && (
                <pre className={`${styles.messageContainer} ${isUser ? 'text-end  ml-auto' : 'text-start mr-auto'} px-4 py-2 bg-themeOverlay`}>
                  {message.messageText}
                </pre>
              )
            }
          </div >
        ) : (
          <pre className={`${styles.messageContainer} ${(message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.MEDIA || message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.BOTH_TEXT_MEDIA) ? `${styles.mediaContainer} p-0` : "px-4 py-2 bg-themeOverlay "}`} >
            {renderMessageContent(message)}
          </pre>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
